__turbopack_context__.v({
  "Container": "ZXOewG_Container",
  "Image": "ZXOewG_Image",
  "Root": "ZXOewG_Root",
  "skeleton-loading": "ZXOewG_skeleton-loading",
});
